export const DynamicHeaderMenuConfig = {
  items: [
    // {
    //   title: 'Dashboard',
    //   root: true,
    //   icon: 'flaticon2-architecture-and-city',
    //   svg: './assets/media/svg/icons/Design/Layers.svg',
    //   page: '/dashboard',
    //   translate: 'MENU.DASHBOARD',
    //   permission: ['Admin','Accountants'],
    //   bullet: 'dot',
    // },
    // {
    //   title: 'Layout Builder',
    //   root: true,
    //   icon: 'flaticon2-expand',
    //   page: '/builder',
    //   svg: './assets/media/svg/icons/Home/Library.svg'
    // },
    {
      title: 'امور حسابداری',
      permission: ['Admin', 'Accountants'],
      bullet: 'dot',
      icon: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Home/Library.svg',
      root: true,
      page: '/ecommerce',
      submenu: [
        {
          title: 'اطلاعات اولیه',
          bullet: 'dot',
          icon: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Home/Library.svg',
          // root: true,
          permission: ['Admin', 'Accountants'],
          page: '/ecommerce',
          submenu: [
            {
              title: 'طرف حساب',
              page: '/ecommerce/customers'
            },
            {
              title: 'لیست محصولات',
              page: '/accounting/productList'
            },
            {
              title: 'لیست قطعات',
              page: '/accounting/matrialList'
            },
            {
              title: 'مدیریت بانک',
              page: '/accounting/Bank'
            },

          ]
        },
        {
          title: 'فاکتور های فروش',
          path: '/accounting/Facors',

          root: true,
          icon: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Code/Right-circle.svg',
          submenu: [
            {
              title: 'فاکتور های فروش',
              page: '/accounting/Facors'
            },
            {
              title: 'فاکتور جدید',
              page: '/accounting/Facors/add'
            },

          ]

        },
        {
          title: 'فاکتور های خرید',
          path: '/accounting/FacorsBuy',
          root: true,
          icon: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Code/Left-circle.svg',
          submenu: [
            {
              title: 'فاکتور های خرید',
              page: '/accounting/FacorsBuy'
            },
            {
              title: 'فاکتور جدید',
              page: '/accounting/FacorsBuy/add'
            },

          ]

        },
        {
          title: 'عملیات سند',
          path: '/accounting/Sanad',
          root: true,
          icon: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Communication/Write.svg',
          submenu: [
            {
              title: 'مرور اسناد',
              page: '/accounting/Sanad'
            },
            {
              title: 'ثبت سند جدید',
              page: '/accounting/Sanad/add'
            },

          ]

        },
        {
          title: 'گزارشات',
          // root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Shopping/Chart-pie.svg',
          permission: ['Admin', 'Accountants'],
          page: '/reporting',
          submenu: [
            {
              title: 'مرور حساب',
              page: '/reporting/Accounting',

            },
            {
              title: 'معین طرف حساب',
              page: '/reporting/ClientMoein'
            },
            {
              title: 'گزارش طلبکاران / بستانکاران',
              page: '/reporting/ClientAccounting'
            }
            ,
            {
              title: 'گزارش  فروش',
              page: '/reporting/SellReport'
            },
            {
              title: ' گزارش  فروش محصولات',
              page: '/reporting/SellProducReport',
            },
            {
              title : 'مرور پرداخت های آنلاین',
              page : '/Payment/report'
            }
          ]
        },
      ]

    },
    {
      title: 'مدیریت',
      permission: ['Admin'],
      submenu: [
        {
          title: 'مدیریت محصولات و قطعات',
          root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Shopping/Box3.svg',
          page: '/Stor',
          permission: ['Admin'],
          submenu: [
            {
              title: 'دسته بندی محصولات',
              page: '/ecommerce/ProductType'
            },
            {
              title: 'محصول',
              page: '/ecommerce/products'
            },
            {
              title: 'مواد اولیه',
              page: '/ecommerce/RowMatrial'
            },
            {
              title: 'قطعات اولیه ',
              page: '/ecommerce/Material'
            },
            {
              title: 'فرمول تولید',
              page: '/ecommerce/Formula'
            }
          ]
        },

        {
          title: 'انبار و آنالیز قیمت',
          root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Code/Warning-2.svg',
          page: '/Stor',
          permission: ['Admin'],
          submenu: [
            {
              title: 'آنالیز قطعات',
              page: '/Stor/SegmentAnalyze',

            },
            {
              title: 'آنالیز قیمت محصولات',
              page: '/Stor/Products'
            }
          ]
        },
        {
          title: 'مدیریت کاربران ',
          root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Files/User-folder.svg',
          page: '/User',
          permission: ['Admin'],
          submenu: [
            {
              title: 'کاربران ',
              page: '/User/usermanagement',

            }
          ]
        },
        {
          title: 'تغییرات قیمت',
          root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Files/User-folder.svg',
          page: '/changesStore',
          permission: ['Admin'],
          submenu: [
            {
              title: 'مرور تغییرات ',
              page: '/changesStore/Changes',

            }
          ]
        },
        {
          title: 'اپلیکیشن',
          root: true,
          bullet: 'dot',
          icone: 'flaticon2-list-2',
          svg: './assets/media/svg/icons/Code/Settings4.svg',
          page: '/AppSetting',
          permission: ['Admin'],
          submenu: [
            {
              title: 'تنظیمات پایه',
              page: '/AppSetting/setting'
            },
            {
              title: 'مدیریت بک آپ',
              page: '/AppSetting/backups'
            },
            {
              title: 'بستن حساب ها ',
              page: '/AppSetting/CloseAccounting'
            }
          ]
        },
      ]
    },
    {
      title: 'انبارداری',
      root: true,
      alignment: 'right',
      toggle: 'click',
      page: '/StoreCheckList',
      permission: ['Admin', 'Accountants', 'Manufacturers'],
    },
    // {section: 'فرایند تولید', permission: ['Admin', 'Accountants', 'Manufacturers'], },
    {
      title: 'تولید',
      root: true,
      alignment: 'right',
      toggle: 'click',
      page: '/manufacuring/Manufacturres',
      permission: ['Admin', 'Accountants', 'Manufacturers'],
    },
    // { section: 'امور همکاران بازدید', permission: ['Admin', 'Accountants', 'Experts'], },
    {
      title: 'بازدید',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Map/Marker1.svg',
      permission: ['Admin', 'Accountants', 'Experts'],
      page: '/expert/Experts',
    },
    // { section: 'همکاران فروش', permission: ['CellPartner'], },
    {
      title: 'مرور سفارشات ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      permission: ['CellPartner'],
      page: '/partners/AccountingPartners',
      
    },
    {
      title: 'گزارش معین ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      permission: ['CellPartner'],
      page: '/partners/report',
      
    },
    // { section: ' اطلاعیه ها ', permission: ['Admin', 'Accountants', 'CellPartner', 'Experts', 'Manufacturers'], },
    {
      title: 'SMS ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      permission: ['Admin', 'Accountants'],
      page: '/Sms',
     
    },
    {
      title: 'مدیریت اطلاعیه ها  ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      permission: ['Admin', 'Accountants'],
      page: '/Notifications/Notifications',
     
    },
    {
      title: ' اطلاعیه ها  ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Communication/Incoming-mail.svg',
      permission: ['Admin', 'Accountants', 'CellPartner', 'Experts', 'Manufacturers'],
      page: '/Notifications/UserNotification',
      
    },
    // { section: ' اخطار ها ', permission: ['Admin'] },
    {
      title: 'مدیریت اخطار ها',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Box3.svg',
      page: '/Warnnings/Browse',
      permission: ['Admin'],
     
    },
    // { section: ' فعالیت کاربران ', permission: ['Admin'] },
    {
      title: 'بررسی فعالیت کاربران ',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Box3.svg',
      page: '/activity/Browse',
      permission: ['Admin'],
      
    },
    {
      title: 'گزارش لیست محصولات انبار',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Design/Layers.svg',
      permission: ['CellPartner'],
      page: '/partners/ProductStore',
      
    },
    {
      title: 'لیست قیمت',
      root: true,
      bullet: 'dot',
      icone: 'flaticon2-list-2',
      svg: './assets/media/svg/icons/Shopping/Box3.svg',
      page: '/PriceList',
      permission: ['Admin','Accountants','CellPartner','Experts','Manufacturers'],
      // submenu: [
      //   {
      //     title: 'کاتالوگ محصولات',
      //     page: '/PriceList'
      //   }
        
      // ]
    },
    // { section: 'Applications' },

    // {
    //   title: 'Error Pages',
    //   root: true,
    //   bullet: 'dot',
    //   icon: 'flaticon2-list-2',
    //   svg: './assets/media/svg/icons/Code/Warning-2.svg',
    //   page: '/error',
    //   submenu: [
    //     {
    //       title: 'Error 1',
    //       page: '/error/error-1'
    //     },
    //     {
    //       title: 'Error 2',
    //       page: '/error/error-2'
    //     },
    //     {
    //       title: 'Error 3',
    //       page: '/error/error-3'
    //     },
    //     {
    //       title: 'Error 4',
    //       page: '/error/error-4'
    //     },
    //     {
    //       title: 'Error 5',
    //       page: '/error/error-5'
    //     },
    //     {
    //       title: 'Error 6',
    //       page: '/error/error-6'
    //     },
    //   ]
    // },
  ]
};
